import React from 'react';
import { Tag } from 'antd';

export enum AccessChangeType {
	NewAccess = 1,
	NewUser = 3,
	NewApp = 4
}

const accessChangeText = {
	[ AccessChangeType.NewAccess ]: 'New Access',
	[ AccessChangeType.NewUser ]: 'New User',
	[ AccessChangeType.NewApp ]: 'New App'
};

const accessChangeColor = {
	[ AccessChangeType.NewAccess ]: 'orange',
	[ AccessChangeType.NewUser ]: 'cyan',
	[ AccessChangeType.NewApp ]: 'purple'
};

export interface AccessChangeTypeTagProps {
	changeType: AccessChangeType;
}

export const AccessChangeTypeTag: React.FC<AccessChangeTypeTagProps> = ({ changeType }) =>
	<Tag
		color={ accessChangeColor[ changeType ] }>
		{ accessChangeText[ changeType ] }
	</Tag>;

